import { Outlet, createFileRoute } from "@tanstack/react-router";

import { AccountingFirmLayout } from "@/components/layouts/accounting-firm-layout";
import { CompanyAdminOnly } from "@/components/shared/miscellaneous/companyadmin-only";

export const Route = createFileRoute("/_authenticated/kanzlei")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <>
      <AccountingFirmLayout>
        <CompanyAdminOnly>
          <Outlet />
        </CompanyAdminOnly>
      </AccountingFirmLayout>
    </>
  );
}
